import { alpha, Typography } from '@mui/material';
import { FC } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  position: absolute;
  right: ${({ theme }) => theme.spacing(1)};
  bottom: ${({ theme }) => theme.spacing(1)};
  border-radius: 100px;
  background: ${({ theme }) => alpha(theme.palette.primary.main, 0.1)};
  padding: ${({ theme }) => theme.spacing(0.5, 1)};
  opacity: 0.5;
`;

type Props = {
  timestamp: string;
};

export const Timestamp: FC<Props> = ({ timestamp }) => (
  <Container>
    <Typography variant="caption" color="textSecondaryInverse">
      {timestamp}
    </Typography>
  </Container>
);
